import BaseBlockMap from './BaseBlockMap';


export default {
    ...BaseBlockMap,
};
